module.exports = __webpack_public_path__ + "img/masters.c8138ecb.png";